/**
 * 独立工具页（非 Chat 工作台）在 1011 积分不足时，与 `handleVideoInsufficientCreditAfterCreateFailure` 对齐：
 * 关充值窗后写入锁定占位并刷新侧栏历史。
 */
import type { CreateImageData } from '~/types'
import { handleVideoInsufficientCreditAfterCreateFailure } from '~/utils/videoInsufficientCreditPreflight'
import { emitOpenGoodsModal } from '~/utils/emitter'

export async function consumeToolPageInsufficientCredit(
    createStore: any,
    res: { status?: number },
    options: {
        kind: 'tool_edit' | 'effect_template'
        /** 与工作台 `toolRegistry` 的 id 一致 */
        toolId?: string
        /** 与 `tool-credit-required` 的 workflowType 一致，用于从 createStore 取积分 */
        creditWorkflowKey: string
        historyCategory?: 'IMAGE' | 'VIDEO' | 'MUSIC' | 'TOOL'
        /** 与当次提交接口相同的请求体字段（用于锁定卡片展示与解锁重放缓存） */
        body: Record<string, unknown>
        /** 特效模板等：锁定卡顶栏第二枚标签（template_name） */
        templateName?: string
    }
): Promise<void> {
    const lockPayload = {
        create_type: options.kind,
        source_type: 'NEW_WERYA',
        credit_workflow_key: options.creditWorkflowKey,
        ...(options.toolId ? { tool_id: options.toolId } : {}),
        ...(options.historyCategory
            ? { credit_lock_history_category: options.historyCategory }
            : {}),
        ...options.body,
        ...(typeof options.templateName === 'string' && options.templateName.trim()
            ? { template_name: options.templateName.trim() }
            : {}),
    } as CreateImageData

    const consumed = await handleVideoInsufficientCreditAfterCreateFailure(
        lockPayload,
        createStore,
        res
    )
    if (!consumed) {
        emitOpenGoodsModal()
    }
}
